// extracted by mini-css-extract-plugin
module.exports = {"list-group":"UserData_list-group__3ZBv0","list-group-item":"UserData_list-group-item__3pfWh","avatar":"UserData_avatar__rEbGl","contsiner":"UserData_contsiner__1sxJu"};